export default __webpack_public_path__ + "static/media/Icon_YOU_ARE_HERE_Large.b71d9df9.svg";